import React from 'react'
import classNames from 'classnames'

import s from './SuggestItem.less'

import SVGIcon from '../svg/SVGIcon'
import { suggestServiceCtx } from '../../store/suggest/suggest.service.constants'
import eventMappingFr from './event_mapping_fr.json'
import eventMappingEn from './event_mapping_en.json'

import { slugify } from '../../utils/string'
import { useSelector } from 'react-redux'
import { selectLocale } from '../../store/locale/locale.selectors'
import { SuggestEventSvg } from './SuggestEventSvg'
import TagActionButton from '../genericComponents/TagActionButton'
import { SUGGEST_CLICK } from '../../store/analytics/analytics.actionTypes'
import { POI_POSITION, POI_TYPE } from '../analytics/ClickTagsService'
import { JO_CELEBRATION_PLACE, JO_EVENT_SITE } from '../../store/geoentity/geoentity.constants'

const BrandItemContent = props => {
  const { suggest = {} } = props
  const { labels, brandIconUrl } = suggest
  const [firstLabel] = labels
  return (
    <>
      {brandIconUrl && (
        <div className={s.brandLogo}>
          <img src={brandIconUrl} />
        </div>
      )}
      <div className={classNames(s.SuggestItem_text, s.oneLabel)}>
        <span className={s.SuggestItem_mainLabel} dangerouslySetInnerHTML={{ __html: firstLabel }} />
      </div>
    </>
  )
}

const GenericContent = props => {
  const { suggest } = props
  const [firstLabel, ...otherLabels] = suggest.labels
  const icon = suggest?.subtype?.id
  const iconUrls = suggest?.iconUrls ?? false

  return (
    <>
      <div className={classNames(s.icon, 'icon', s[icon])}>
        <SVGIcon icon={icon} />
      </div>
      <div className={classNames(s.SuggestItem_text, otherLabels.length === 0 && s.oneLabel)}>
        <span className={s.SuggestItem_mainLabel} dangerouslySetInnerHTML={{ __html: firstLabel }} />
        {iconUrls && (
          <span>
            {iconUrls.map((iconUrl, idx) => {
              return <img className={s.SuggestItem_icon} key={`${firstLabel}-${idx}`} src={iconUrl} />
            })}
          </span>
        )}
        {!iconUrls && (
          <span className={s.SuggestItem_secondaryLabel}>
            {otherLabels.map((label, id) => (
              <span key={id} dangerouslySetInnerHTML={{ __html: label }} />
            ))}
          </span>
        )}
      </div>
    </>
  )
}

const EventContent = props => {
  const { suggest } = props
  const icon = suggest?.subtype?.id
  const locale = useSelector(selectLocale)
  const eventMapping = locale.startsWith('en') || locale.startsWith('nl') ? eventMappingEn : eventMappingFr
  const { address_components } = suggest
  const postcode = address_components?.postcodes?.[0]
  const town = address_components?.town?.label
  const address = postcode && town ? `${postcode}, ${town}` : undefined
  const otherName = address_components?.other_name
  const eventAssets = eventMapping[slugify(address_components?.name)]

  return (
    <>
      <div className={classNames(s.icon, 'icon', s[icon])}>
        <SVGIcon icon={icon} />
      </div>
      <div className={classNames(s.SuggestItem_text)}>
        <span
          className={classNames(s.SuggestItem_mainLabel, s.SuggestItem_eventLabel)}
          dangerouslySetInnerHTML={{ __html: suggest.labels[0] }}
        />
        {otherName && (
          <span className={classNames(s.SuggestItem_mainLabel, s.SuggestItem_eventLabel)}>{otherName}</span>
        )}
        {address && (
          <span className={classNames(s.SuggestItem_secondaryLabel, s.SuggestItem_eventLabel)}>
            <span>{address}</span>
          </span>
        )}

        <div>
          <SuggestEventSvg iconName={'JO_Paris_2024'} />
          {eventAssets?.map(asset => (
            <SuggestEventSvg key={asset} iconName={asset} />
          ))}
        </div>
      </div>
    </>
  )
}

const SuggestItemContent = ({ type, suggest, isEventSuggest }) => {
  if (type === suggestServiceCtx.type.store_chain) {
    return <BrandItemContent suggest={suggest} />
  } else if (isEventSuggest) {
    return <EventContent suggest={suggest} />
  } else {
    return <GenericContent suggest={suggest} />
  }
}

const SuggestItem = props => {
  const { suggest, idx } = props

  const isEventSuggest = suggest?.subtype?.id === JO_EVENT_SITE || suggest?.subtype?.id === JO_CELEBRATION_PLACE

  const type = suggest?.type

  const onClick = e => {
    e.preventDefault()
    e.stopPropagation()
    const { onClick, suggest } = props
    onClick && onClick(suggest)
  }

  const onMouseEnter = () => {
    const { idx, updateSelectedId } = props
    updateSelectedId(idx)
  }

  const onFocus = () => {
    const { idx, updateSelectedId } = props
    updateSelectedId(idx)
  }

  return (
    <TagActionButton
      type={SUGGEST_CLICK}
      tagInfo={{
        [POI_TYPE]: suggest?.subtype?.id,
        [POI_POSITION]: idx + 1
      }}
      className={classNames(s.SuggestItem_link, isEventSuggest && s.SuggestEventItem_link)}
      {...{
        onClick,
        onMouseEnter,
        onFocus
      }}
    >
      <SuggestItemContent type={type} suggest={suggest} isEventSuggest={isEventSuggest} />
    </TagActionButton>
  )
}

export default SuggestItem
